import React from 'react';
import { KliBaseField } from '../Base/';

export const KliField = React.forwardRef(({ ...props }, ref) => {
    return <KliBaseField ref={ref} {...props} />;
});

KliField.displayName = 'KliField';
